import { render, staticRenderFns } from "./productfeature.vue?vue&type=template&id=b7dc894e&scoped=true"
import script from "./productfeature.vue?vue&type=script&lang=js"
export * from "./productfeature.vue?vue&type=script&lang=js"
import style0 from "./productfeature.vue?vue&type=style&index=0&id=b7dc894e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dc894e",
  null
  
)

export default component.exports